function cleanUrl(url) {
	return url.replace(/[^A-Za-z0-9/]+/g, '-').toLowerCase();
}

export function facilityUrl(facility) {
	if (!facility || !facility.seoLocation) {
		return '';
	}
	const { id, seoLocation, name, inNetwork } = facility;
	const { city, fullState } = seoLocation;
	const title = `${name.replace(/[^a-z0-9]/gi, '-')}-${id}`;
	let url = `/self-storage/${fullState}/${city}/${inNetwork ? '' : 'ogf/'}${title}/`;
	url = cleanUrl(url);
	return url;
}
